import { render, staticRenderFns } from "./EditRefer.vue?vue&type=template&id=664ec0ca&scoped=true"
import script from "./EditRefer.vue?vue&type=script&lang=js"
export * from "./EditRefer.vue?vue&type=script&lang=js"
import style0 from "./EditRefer.vue?vue&type=style&index=0&id=664ec0ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664ec0ca",
  null
  
)

export default component.exports